import React from "react";
import { useQuery } from "@apollo/client/react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

import { FETCH_PROJECT_QUERY } from "../constants/graphql/queries";

export const ProjectContext = React.createContext(null);

export const ProjectProvider = ({ children, id, loadingComponent = null }) => {
  const { data: { project = {} } = {}, loading } = useQuery(FETCH_PROJECT_QUERY, {
    variables: { id },
    skip: !id,
  });

  if (loading) {
    if (loadingComponent) {
      return loadingComponent;
    }

    return (
      <Box p={3} display="flex" justifyContent="center" width="100%">
        <CircularProgress />
      </Box>
    );
  }

  return <ProjectContext.Provider value={project}>{children}</ProjectContext.Provider>;
};

export const useProject = () => {
  const context = React.useContext(ProjectContext);
  if (context === undefined) {
    throw new Error("useProject must be used within a ProjectProvider");
  }
  return context;
};
